var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "boss-main-container" }, [
    _c(
      "div",
      { staticClass: "boss-main-wrap boss-main-content-wrap" },
      [
        _c("setting-header", {
          attrs: {
            breadcrumbs: [{ name: "各種設定" }],
            title: "パスワード変更",
          },
        }),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        _c("form-item", {
          attrs: {
            label: "旧パスワード",
            type: "password",
            "data-test": "current-password",
          },
          model: {
            value: _vm.currentPassword,
            callback: function ($$v) {
              _vm.currentPassword = $$v
            },
            expression: "currentPassword",
          },
        }),
        _vm._v(" "),
        _c("form-item", {
          attrs: {
            label: "新パスワード",
            type: "password",
            "class-name":
              _vm.isInvalidPassword || _vm.isSameCurrentAndNewPassword
                ? "is-invalid-input"
                : "",
            "data-test": "new-password",
          },
          scopedSlots: _vm._u([
            {
              key: "error",
              fn: function () {
                return [
                  _vm.isInvalidPassword
                    ? _c("validation-label", {
                        attrs: {
                          label:
                            "半角英数混在8文字以上20文字以内で入力してください。",
                          "data-test": "new-password-validation",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isSameCurrentAndNewPassword
                    ? _c("validation-label", {
                        attrs: {
                          label:
                            "現在のパスワードと異なるものを入力してください。",
                          "data-test": "is-same-current-and-new-password",
                        },
                      })
                    : _vm._e(),
                ]
              },
              proxy: true,
            },
          ]),
          model: {
            value: _vm.newPassword,
            callback: function ($$v) {
              _vm.newPassword = $$v
            },
            expression: "newPassword",
          },
        }),
        _vm._v(" "),
        _c("form-item", {
          attrs: {
            label: "新パスワード (確認用)",
            type: "password",
            "class-name": _vm.isDifferentNewPassword ? "is-invalid-input" : "",
            "data-test": "confirm-new-password",
          },
          scopedSlots: _vm._u([
            {
              key: "error",
              fn: function () {
                return [
                  _vm.isDifferentNewPassword
                    ? _c("validation-label", {
                        attrs: {
                          label:
                            "新パスワードと新パスワード(確認用)が一致しません。",
                          "data-test": "is-same-new-password-confirm",
                        },
                      })
                    : _vm._e(),
                ]
              },
              proxy: true,
            },
          ]),
          model: {
            value: _vm.confirmNewPassword,
            callback: function ($$v) {
              _vm.confirmNewPassword = $$v
            },
            expression: "confirmNewPassword",
          },
        }),
        _vm._v(" "),
        _c(
          "form-button-area",
          [
            _c("form-confirm-button", {
              attrs: {
                "is-disabled": _vm.isDisable,
                "submit-label": "パスワードを変更する",
                "data-test": "confirm-button",
              },
              on: { "submit-event": _vm.changePassword },
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "grid-x align-justify" }, [
      _c("div", { staticClass: "medium-6 cell" }, [
        _c("p", [_vm._v("下記の項目を入力してください。")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }